import { Modal, Button } from "react-bootstrap";
import styles from "../common/modal/Popup.module.css";
import { useEffect, useState } from "react";
import { Alert, Col, Form, Row } from "react-bootstrap";
import { CheckCircle, Eye, EyeSlash, XCircle } from "react-bootstrap-icons";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Validation from "../../hooks/Validation";
import { changePassword } from "../../store/actions/adminAction";
import { adminReset } from "../../store/reducerSlice/admin";
import Loader from "../common/loader/Loader";
const formElements = [
  {
    key: "oldPassword",
    label: "Current Password",
    placeHolder: "Enter current password",
    type: "password",
  },
  {
    key: "newPassword",
    label: "New Password",
    placeHolder: "Enter new password",
    type: "password",
  },
  {
    key: "confirmPassword",
    label: "Confirm Password",
    placeHolder: "Confirm new password",
    type: "password",
  },
];

const ResetPasswordFormPopup = ({
  resetPasswordRec,
  onHide,
  resetPasswordModalShow,
  setResetPasswordModalShow,
}) => {
  const [passwordDetail, setPasswordDetail] = useState({
    oldPassword: null,
    newPassword: null,
    confirmPassword: null,
  });
  const [eyes, setEyes] = useState({
    newPassword: false,
    confirmPassword: false,
    oldPassword: false,
  });
  const [successMessage, setSuccessMessage] = useState(null);

  const [error, checkValidator, resetValidator, resetAllValidator, isError] =
    Validation(passwordDetail);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {
    adminDetail,
    isLoader,
    isRecordUpdated,
    error: apiError,
  } = useSelector((state) => state.admin);

  const submitHandler = (e) => {
    e.preventDefault();
    checkValidator();

    const { newPassword, confirmPassword, oldPassword } = passwordDetail;
    dispatch(
      changePassword({
        adminId: adminDetail.adminId,
        newPassword: newPassword,
        oldPassword: oldPassword,
        confirmPassword: confirmPassword,
      })
    ).then(({ payload }) => {
      if (payload?.success) {
        setSuccessMessage(payload?.message);
        setPasswordDetail({
          newPassword: null,
          confirmPassword: null,
          oldPassword: null,
        });
        setTimeout(() => {
          hideHandler();
        }, 3000);
      }
    });
  };

  useEffect(() => {
    return () => {
      dispatch(adminReset());
    };
  }, []);

  const hideHandler = () => {
    resetAllValidator();
    onHide();
    setResetPasswordModalShow(false);
    setPasswordDetail({
      newPassword: null,
      confirmPassword: null,
    });
    setSuccessMessage(null);
    dispatch(adminReset());
  };

  return (
    <Modal
      show={resetPasswordModalShow}
      onHide={hideHandler}
      aria-labelledby="contained-modal-title-vcenter"
      className={styles.modal}
      centered
      title={"Resend Reset Password Link"}
    >
      <Modal.Header closeButton className="mb-0">
        <Modal.Title id="contained-modal-title-vcenter">
          {"Update Password"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body style={{marginTop:'-30px'}}>
        <Form
          onSubmit={(e) => submitHandler(e)}
          style={{
            maxWidth: 600,
            margin: "0 auto",
            background: "none",
            boxShadow: "none",
          }}
          noValidate
        >
          {/* <h1 className={Styles.h1}>Login</h1> */}
          {isLoader && <Loader />}
          {apiError && (
            <Alert variant={"danger"}>
              {apiError?.message || "Access denied! Please try again"}
            </Alert>
          )}
          {successMessage && (
            <Alert variant={"success"}>{successMessage}</Alert>
          )}
          {formElements.map((element, i) => {
            return (
              <Form.Group
                className="mb-4 rowField"
                controlId="formBasicEmail"
                key={i}
              >
                <Form.Label>
                  {element.label} <span className="required">*</span>
                </Form.Label>
                <Form.Control
                  type={eyes[element.key] ? "text" : element.type}
                  name={element.key}
                  placeholder={element.placeHolder}
                  value={passwordDetail && passwordDetail[element.key]}
                  onChange={(e) => {
                    setPasswordDetail({
                      ...passwordDetail,
                      [element.key]: e.target.value,
                    });
                    // resetValidator(e.target.name);
                    // checkValidator(element.key)
                  }}
                  onKeyUp={(e) => {
                    //(passwordDetail && passwordDetail[element.key] && element.key === 'newPassword') &&
                    checkValidator(element.key);
                  }}
                  isInvalid={
                    error &&
                    error !== null &&
                    typeof error[element.key] !== "object" &&
                    error[element.key]
                  }
                />
                <div
                  className="eyeIcon"
                  onClick={(e) =>
                    setEyes({
                      ...eyes,
                      [element.key]: !eyes[element.key],
                    })
                  }
                >
                  {eyes[element.key] ? <Eye /> : <EyeSlash />}
                </div>
                <Form.Control.Feedback type="invalid">
                  {error &&
                    error !== null &&
                    typeof error[element.key] !== "object" &&
                    error[element.key]}
                </Form.Control.Feedback>
                {element.key === "newPassword" && (
                  <Form.Text
                    className={`passwordRules ${
                      error && passwordDetail[element.key] && "valid"
                    }`}
                  >
                    <h3>Your password must have:</h3>
                    <p
                      className={
                        passwordDetail[element.key]
                          ? error &&
                            error?.newPassword?.lowercase &&
                            error[element.key]?.lowercase
                            ? "invalid"
                            : ""
                          : ""
                      }
                    >
                      {!passwordDetail?.newPassword ? (
                        <XCircle />
                      ) : error?.newPassword?.lowercase ? (
                        <XCircle />
                      ) : (
                        <CheckCircle />
                      )}{" "}
                      At least one lowercase letter
                    </p>
                    <p
                      className={
                        passwordDetail[element.key]
                          ? error &&
                            error?.newPassword?.uppercase &&
                            error[element.key]?.uppercase
                            ? "invalid"
                            : ""
                          : ""
                      }
                    >
                      {!passwordDetail?.newPassword ? (
                        <XCircle />
                      ) : error?.newPassword?.uppercase ? (
                        <XCircle />
                      ) : (
                        <CheckCircle />
                      )}{" "}
                      At least one UPPERCASE letter
                    </p>
                    <p
                      className={
                        passwordDetail[element.key]
                          ? error &&
                            error?.newPassword?.number &&
                            error[element.key]?.number
                            ? "invalid"
                            : ""
                          : ""
                      }
                    >
                      {!passwordDetail?.newPassword ? (
                        <XCircle />
                      ) : error?.newPassword?.number ? (
                        <XCircle />
                      ) : (
                        <CheckCircle />
                      )}{" "}
                      At least one number
                    </p>
                    <p
                      className={
                        passwordDetail[element.key]
                          ? error &&
                            error?.newPassword?.special &&
                            error[element.key]?.special
                            ? "invalid"
                            : ""
                          : ""
                      }
                    >
                      {!passwordDetail?.newPassword ? (
                        <XCircle />
                      ) : error?.newPassword?.special ? (
                        <XCircle />
                      ) : (
                        <CheckCircle />
                      )}{" "}
                      At least one special character
                    </p>
                    <p
                      className={
                        passwordDetail[element.key]
                          ? error &&
                            error?.newPassword?.length &&
                            error[element.key]?.length
                            ? "invalid"
                            : ""
                          : ""
                      }
                    >
                      {!passwordDetail?.newPassword ? (
                        <XCircle />
                      ) : error?.newPassword?.length ? (
                        <XCircle />
                      ) : (
                        <CheckCircle />
                      )}{" "}
                      At least 8 characters
                    </p>
                  </Form.Text>
                )}
              </Form.Group>
            );
          })}
          <div className="requiredNote">
            Note: You must complete all the mandatory fields.
          </div>
          <br />
          <div className="d-flex justify-content-around">
            <Button className="mx-3" variant="outline-secondary model-btn" onClick={hideHandler}>
              Close
            </Button>
            <Button className="btn-primary mx-3 model-btn" type="submit">
              Update
            </Button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default ResetPasswordFormPopup;
